import { SAVE_XERO_TAX_RATES } from '../../../../../../constants/constant_xero';


export function showXeroTaxModal() {
  return { type: 'SHOW_XERO_TAX_MODAL' };
}

export function hideXeroTaxModal() {
  return { type: 'HIDE_XERO_TAX_MODAL' };
}

export function resetXeroTaxModal() {
  return { type: 'RESET_XERO_TAX_MODAL' };
}

export function setDataXeroTaxModal(data) {
  return { type: 'SET_DATA_XERO_TAX_MODAL', payload: data };
}

export function setInfoXeroTaxModal(infos) {
  return { type: 'SET_INFO_XERO_TAX_MODAL', payload: infos };
}

export function clearInfoXeroTaxModal() {
  return { type: 'SET_INFO_XERO_TAX_MODAL' };
}

export function setErrorXeroTaxModal(errors) {
  if (errors.meta) {
    const payload = errors.meta.errors.map((m) => ({ message: m.Message }));
    return { type: 'SET_ERROR_XERO_TAX_MODAL', payload };
  }

  return { type: 'SET_ERROR_XERO_TAX_MODAL', payload: errors };
}

export function clearErrorXeroTaxModal() {
  return { type: 'CLEAR_ERROR_XERO_TAX_MODAL' };
}

export function saveXeroTaxRate(integrationId, data) {
  return { type: SAVE_XERO_TAX_RATES, integrationId, data };
}
